/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { Technology } from '../../constants/installation';

type getFilenameOptions = {
	type: 'html' | 'css' | 'exportCss' | 'js' | 'vueMainJs';
	selectedTechnology: Technology;
};

export function getFilename( { type, selectedTechnology }: getFilenameOptions ): string {
	switch ( type ) {
		case 'html':
			switch ( selectedTechnology ) {
				case 'angular':
					return 'app.component.html';
				default:
					return 'index.html';
			}

		case 'css':
			switch ( selectedTechnology ) {
				case 'react':
					return 'App.css';
				case 'angular':
					return 'app.component.css';
				default:
					return 'style.css';
			}

		case 'exportCss':
			return 'export-style.css';

		case 'js':
			switch ( selectedTechnology ) {
				case 'react':
					return 'App.jsx';
				case 'vue':
					return 'App.vue';
				case 'angular':
					return 'app.component.ts';
				default:
					return 'main.js';
			}

		case 'vueMainJs':
			return 'main.js';
	}
}
